<template>
  <div class="item footer">
    <div class="container hidden-xs wow slideInUp">
      <div class="col-xs-12 col-sm-6 left">
        <p class="company-name">北京原誉神数字科技有限公司</p>
        <div class="company-info">
          <p>电话：18101282376</p>
          <p>地址：北京市朝阳区望京保利·国际广场-T1-9层</p>
          <p>邮箱：yuanyushen@magicchair.net</p>
          <p>
            <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              >京ICP备2022027952号-1</a
            >
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 right">
        <div>
          <img
            src="https://alggxcx.magicchair.net/uccn/index_bottom_ewm1.svg"
            alt=""
          />
          <p class="text-center">扫码进入微信公众号</p>
        </div>
        <div>
          <img
            src="https://alggxcx.magicchair.net/uccn/index_bottom_ewm1.svg"
            alt=""
          />
          <p class="text-center">扫码进入抖音官方账号</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
.footer {
  padding: 107px 0;
  background: #000;
  .company-name {
    font-size: 24px;
    margin-bottom: 30px;
    color: #fff;
  }
  .company-info {
    p {
      color: #999999;
      margin-top: 23px;
      a {
        text-decoration: none;
        color: #999999;
      }
    }
  }
  .right {
    display: flex;
    justify-content: flex-end;
    div {
      p {
        color: #999999;
        font-size: 16px;
        margin-top: 20px;
      }
      &:last-child {
        margin-left: 90px;
      }
    }
  }
}
</style>
